module.exports = __webpack_public_path__ + "img/rectangle-2.4ce49d71.svg";